import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import AdminDashboard from "../components/AdminDashboard";
import ManagerDashboard from "../components/ManagerDashboard";

const Dashboard = () => {
    const { user } = useContext(AuthContext);

    const userGroups = user?.groups || [];

    // Check for user roles (Admin or Manager - mutually exclusive)
    const isAdmin = userGroups.some((group) => group.includes("AdminUserGroup"));
    const isManager = !isAdmin && userGroups.some((group) => group.includes("ManagerUserGroup"));

    return (
        <div className="h-screen w-screen overflow-hidden">
            {isAdmin && <AdminDashboard />}
            {isManager && <ManagerDashboard />}
            {!isAdmin && !isManager && (
                <div className="flex items-center justify-center h-full">
                    <p className="text-red-500 text-lg font-semibold">
                        You do not have access to any dashboards.
                    </p>
                </div>
            )}
        </div>
    );
};

export default Dashboard;
